import { useTheme } from '@mui/material/styles';
import { URLS, FONTS } from '../../../config/app-config';
import React, { useState } from 'react';
import {
    Dialog,
    DialogContent,
    DialogTitle,
    Box,
    Paper,
    Typography,
    IconButton,
    Tab,
    Tabs,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useAuth } from '../../../auth/AuthProvider';
import ReleaseManagement from './ReleaseManagement';
import FeedbackEvaluation from './FeedbackEvaluation';
import Analytics from './Analytics';
import ApiKeyManagement from './ApiKeyManagement';
import JobManagement from './JobManagement';

const AdminDashboard = ({ open, onClose }) => {
    const theme = useTheme();
    const { user, isAuthenticated, login } = useAuth();

    // Admin-API-Basis
    const adminApiBase = URLS.apiBase.replace(/\/$/, '') + '/';

    // Tab state
    const [activeTab, setActiveTab] = useState('release');
    const tabs = [
        { id: 'release', label: 'Releases' },
        { id: 'api-keys', label: 'API Keys' },
        { id: 'jobs', label: 'Jobs' },
        { id: 'feedback', label: 'Feedback' },
        { id: 'analytics', label: 'Analytics' }
    ];

    return (
        <Dialog open={open} onClose={onClose} fullScreen>
            {/* HEADER */}
            <DialogTitle
                disableTypography
                sx={{ m: 0, p: 2, bgcolor: theme.palette.primary.main, color: 'common.white' }}
            >
                <Box display="flex" alignItems="center" justifyContent="space-between">
                    <Typography
                        variant="h6"
                        noWrap
                        sx={{ fontFamily: FONTS.heading, fontWeight: 700 }}
                    >
                        Admin Dashboard
                    </Typography>
                    <IconButton edge="end" color="inherit" onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                </Box>
            </DialogTitle>

            <DialogContent sx={{ p: 0 }}>
                <Box sx={{ maxWidth: 1200, mx: 'auto', px: { xs: 2, md: 3 }, py: 3 }}>
                    {/* Centered tab navigation */}
                    <Paper variant="outlined" sx={{ borderRadius: 2, mb: 3, overflow: 'hidden' }}>
                        <Tabs
                            value={activeTab}
                            onChange={(_event, value) => setActiveTab(value)}
                            variant="fullWidth"
                        >
                            {tabs.map((tab) => (
                                <Tab
                                    key={tab.id}
                                    value={tab.id}
                                    label={tab.label}
                                    sx={{ fontFamily: FONTS.heading }}
                                />
                            ))}
                        </Tabs>
                    </Paper>

                    {/* One panel contains the complete active dashboard view. */}
                    <Paper variant="outlined" sx={{ borderRadius: 2, overflow: 'hidden' }}>
                        {activeTab === 'release' && (
                            <ReleaseManagement
                                open={open}
                                onClose={onClose}
                                user={user}
                                isAuthenticated={isAuthenticated}
                                login={login}
                                adminApiBase={adminApiBase}
                            />
                        )}
                        {activeTab === 'feedback' && (
                            <FeedbackEvaluation
                                open={open}
                                onClose={onClose}
                                user={user}
                                isAuthenticated={isAuthenticated}
                                login={login}
                                adminApiBase={adminApiBase}
                            />
                        )}

                        {activeTab === 'api-keys' && (
                            <ApiKeyManagement
                                open={open}
                                isAuthenticated={isAuthenticated}
                                login={login}
                                adminApiBase={adminApiBase}
                            />
                        )}

                        {activeTab === 'jobs' && (
                            <JobManagement
                                open={open}
                                isAuthenticated={isAuthenticated}
                                login={login}
                                adminApiBase={adminApiBase}
                            />
                        )}

                        {activeTab === 'analytics' && (
                            <Analytics
                                open={open}
                                onClose={onClose}
                                user={user}
                                isAuthenticated={isAuthenticated}
                                login={login}
                                adminApiBase={adminApiBase}
                            />
                        )}
                    </Paper>
                </Box>
            </DialogContent>
        </Dialog>
    );
};

export default AdminDashboard;
